import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from 'components/messages/ErrorBox';
import { usePageLoadingContext } from 'components/messages/PageLoading';
import { useLocale } from 'components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from 'components/special/apiCall';
import ActionHeader from './../components/ActionHeader';
import ActionFooter from '../components/ActionFooter';
import SubjectSearch from './../components/SubjectSearch';
import ListHeader from './../../components/form/ListHeader';
import ListTable from './../../components/form/ListTable';
import TextRegno from './../../components/text/TextRegno';
import TextAmount from 'components/text/TextAmount';
import TextDate from 'components/text/TextDate';
import ReactTooltip from 'react-tooltip';

const OTHERWEB_URL = process.env.REACT_APP_ILWEB_URL ? process.env.REACT_APP_ILWEB_URL.replace(/\/$/, '') : '';
const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const ClaimDDUploadOverview = ({history}) => {
  
  const params = new URLSearchParams(useLocation().search);    
  
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);

  const { t } = useLocale();

   //Init blank formdata record.
   const [formData, setFormData] = useState({       
       claimID : null
    });  

  //Init blank working data record
  const [actionData, setActionData] = useState({    
    claimNumber : "",
    activeRecords : [],
    deActivateRecords : [],
    errorRecords : []   
  });


  const goBack = () => {
      //Go back to the main claim detail window.
    if (!formData.claimid){
        history.goBack();
    }
    else{
        history.push(OTHERWEB_URL + "/claim-detail/"+ formData.claimid);
    }    
  }

  const loadFormData = async() => {    
    let newFormData = {...formData};    
    //Read the query parameters, if we don´t have any then go back  
    newFormData.claimID = params.get("claimid");    
    console.log("newformData", newFormData);
    if (newFormData.claimID == null || newFormData.claimID <= 0){      
        goBack();
    }        
    
    //Load action data.
    let requestResult = await apiGetCall(BASE_URL + '/addon/ddupload/overview/' + newFormData.claimID);       
    console.log("ActionInit data", requestResult);
    if (isResultOk(requestResult, setListError, true)){
      setActionData(requestResult);                
    }  

    setFormData(newFormData);
    setListLoading(false);
  }

  useEffect(() => {
    loadFormData();
  }, []);

  const onBackClick = () => {    
    goBack();
  }

  ReactTooltip.rebuild();
    
  return (
    <div>
      <ActionHeader title={t("Yfirlit yfir stöðu mála á vanskilaskrá")} claimNumber={actionData.claimNumber}  />
      
      <h4>Mál á skrá</h4>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {actionData.activeRecords}
          colsettings = {['12%','15%','20%','13%','10%','13%','']}
          headers = {[
            t("Dags.kröfu"),
            t("Kennitala"),            
            t("Nafn"),
            t("Tegund"),            
            t("Höfuðstóll"),
            t("Skráð"),
            t("Staða")            
          ]}
          columns = {[
            (item) => <TextDate value={item.claimDate}/>,                               
            (item) => <TextRegno value={item.subjectRegno}/>,
            (item) => <>{item.subjectName}</>,                        
            (item) => <span data-id='tooltip1' data-tip={item.uploadTypeName}>{item.uploadTypeID}</span>,                                    
            (item) => <TextAmount value={item.capital}/>,
            (item) => <TextDate value={item.registerRequestDate}/>,                               
            (item) => <>{!item.awaitingDeregistration && <span>{item.statusName}</span>} {item.awaitingDeregistration && <> <span><s>{item.statusName}</s></span> <br/><i className="icon-warning no-text"/> <TextDate value={item.deregistrationRequestDate}/> <span>Afskráningarbeðini í vinnslu</span></>} </>,                              
          ]}/>
      <h4>Afskráð mál</h4>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {actionData.deActiveRecords}
          colsettings = {['12%','15%','20%','15%','10%','13%','13%']}
          headers = {[
            t("Dags.kröfu"),
            t("Kennitala"),            
            t("Nafn"),
            t("Tegund"),            
            t("Höfuðstóll"),
            t("Skráð"),
            t("Afskráð"),            
          ]}
          columns = {[
            (item) => <TextDate value={item.claimDate}/>,                               
            (item) => <TextRegno value={item.subjectRegno}/>,
            (item) => <>{item.subjectName}</>,                        
            (item) => <span data-id='tooltip1' data-tip={item.uploadTypeName}>{item.uploadTypeID}</span>,                                    
            (item) => <TextAmount value={item.capital}/>,
            (item) => <TextDate value={item.registerRequestDate}/>,                               
            (item) => <TextDate value={item.deregistrationRequestDate}/>,                                           
          ]}/>

      <h4>Mál sem hafa fengið villu eða hafnað</h4>
      <ListTable
          error = {listError}
          isLoading = {listLoading}
          list = {actionData.errorRecords}
          colsettings = {['12%','12%','20%','6%','10%','12%','']}
          headers = {[
            t("Dags.kröfu"),
            t("Kennitala"),            
            t("Nafn"),
            t("Tegund"),            
            t("Höfuðstóll"),
            t("Skráð-Afskráð"),
            t("Staða"),            
          ]}
          columns = {[
            (item) => <TextDate value={item.claimDate}/>,                               
            (item) => <TextRegno value={item.subjectRegno}/>,
            (item) => <>{item.subjectName}</>,                        
            (item) => <span data-id='tooltip1' data-tip={item.uploadTypeName}>{item.uploadTypeID}</span>,                                    
            (item) => <TextAmount value={item.capital}/>,
            (item) => <TextDate value={item.registerRequestDate}/>,                               
            (item) => <>{item.statusName}
              <ul>
                {item.errors.map((errItem, index) =><li key={index}>{errItem.errorMessage}</li>)}                      
              </ul>
            </>,                        
          ]}/>

          
      {/* <ActionFooter actioninit={actionData} onCancel={onBackClick} onSubmit={onSaveClick} /> */}
      <ReactTooltip id={'tooltip1'}/>
    </div>
  );
}

